import login from "../api/login";
import activity from "../api/activity";
import order from "../api/order";

export default {
  login,
  activity,
  order
};
